module.exports = __webpack_public_path__ + "img/product_1_4.c18369c7.jpg";